module.exports = __webpack_public_path__ + "img/deepDive.4781ea8e.png";